import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import { ROUTES } from '../../constants/routes';

function HelpPage() {
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [info, setInfo] = useState({
    appVersion: '',
    versionDocsUrl: null,
    supportEmail: 'help@covecommunities.com',
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get('/api/help/info', {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setInfo(data);
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.error || err.message || 'Failed to load help information');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const supportEmail = info.supportEmail || 'help@covecommunities.com';
  const mailto = `mailto:${supportEmail}`;

  return (
    <div className="container mt-4 app-shell-page">
      <div className="app-layout-bar d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
        <h1 className="h3 mb-0">Help</h1>
        <button
          type="button"
          className="btn btn-sm bg-white text-dark border"
          onClick={() => navigate(ROUTES.HOME)}
        >
          Back to Compass home
        </button>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-8">
          {error && <div className="alert alert-danger">{error}</div>}

          {loading ? (
            <p className="text-muted">Loading…</p>
          ) : (
            <>
              <section className="card app-card mb-3">
                <div className="card-body">
                  <h2 className="h5 card-title">Support</h2>
                  <p className="text-muted small mb-2">
                    Contact Cove Communities support for account or application issues.
                  </p>
                  <p className="mb-2">
                    <a href={mailto}>{supportEmail}</a>
                  </p>
                  <a href={mailto} className="btn btn-outline-primary btn-sm">
                    Email support
                  </a>
                </div>
              </section>

              <section className="card app-card mb-3">
                <div className="card-body">
                  <h2 className="h5 card-title">Version</h2>
                  <p className="mb-0">
                    <span className="text-muted">Application version:</span>{' '}
                    <strong>{info.appVersion || '—'}</strong>
                  </p>
                </div>
              </section>

              <section className="card app-card mb-4">
                <div className="card-body">
                  <h2 className="h5 card-title">Documentation</h2>
                  {info.versionDocsUrl ? (
                    <a
                      href={info.versionDocsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-secondary btn-sm"
                    >
                      Open version documentation
                    </a>
                  ) : (
                    <p className="text-muted mb-0 small">
                      Not configured — contact your administrator.
                    </p>
                  )}
                </div>
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default HelpPage;
